/**
 * Create a DOM element with attributes and children.
 * @param {string} tag - HTML tag name
 * @param {Object|null} attrs - Attributes/properties to set
 * @param {...(Node|string)} children - Child elements or text
 * @returns {HTMLElement}
 */
export function el(tag, attrs, ...children) {
  const element = document.createElement(tag);

  if (attrs) {
    for (const [key, value] of Object.entries(attrs)) {
      if (key === 'className') {
        element.className = value;
      } else if (key === 'style' && typeof value === 'object') {
        Object.assign(element.style, value);
      } else if (key.startsWith('on') && typeof value === 'function') {
        const eventName = key.slice(2).toLowerCase();
        element.addEventListener(eventName, value);
      } else if (key === 'dataset') {
        Object.assign(element.dataset, value);
      } else if (key === 'htmlFor') {
        element.htmlFor = value;
      } else {
        element.setAttribute(key, value);
      }
    }
  }

  for (const child of children) {
    if (child == null || child === false) continue;
    if (typeof child === 'string' || typeof child === 'number') {
      element.appendChild(document.createTextNode(String(child)));
    } else if (child instanceof Node) {
      element.appendChild(child);
    } else if (Array.isArray(child)) {
      child.forEach(c => {
        if (c instanceof Node) element.appendChild(c);
        else if (c != null && c !== false) element.appendChild(document.createTextNode(String(c)));
      });
    }
  }

  return element;
}

/**
 * Parse an HTML string and return the first element.
 * @param {string} html
 * @returns {HTMLElement}
 */
export function html(htmlStr) {
  const template = document.createElement('template');
  template.innerHTML = htmlStr.trim();
  return template.content.firstElementChild;
}

/**
 * Remove all children of an element.
 */
export function clearChildren(element) {
  while (element.firstChild) {
    element.removeChild(element.firstChild);
  }
}
